import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const progressCircleDefaultVariants = {}
const progressCircleCompoundVariants = []

const progressCircleSlotNames = [
  [
    "root",
    "progress-circle__root"
  ],
  [
    "track",
    "progress-circle__track"
  ],
  [
    "range",
    "progress-circle__range"
  ],
  [
    "valueText",
    "progress-circle__valueText"
  ]
]
const progressCircleSlotFns = /* @__PURE__ */ progressCircleSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, progressCircleDefaultVariants, getSlotCompoundVariant(progressCircleCompoundVariants, slotName))])

const progressCircleFn = memo((props = {}) => {
  return Object.fromEntries(progressCircleSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const progressCircleVariantKeys = [
  "variant"
]
const getVariantProps = (variants) => ({ ...progressCircleDefaultVariants, ...compact(variants) })

export const progressCircle = /* @__PURE__ */ Object.assign(progressCircleFn, {
  __recipe__: false,
  __name__: 'progressCircle',
  raw: (props) => props,
  variantKeys: progressCircleVariantKeys,
  variantMap: {
  "variant": [
    "green",
    "orange",
    "warning",
    "red",
    "dimmed"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, progressCircleVariantKeys)
  },
  getVariantProps
})